import { Text } from '@avanta/shared/components/Text';
import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { ChevronLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router';
import { PageHeader } from 'components/PageHeader';
import { ROUTES } from 'constants/routes';
import { ActivePatientRecord } from './components/ActivePatientRecord';
import { AppointmentsHistory } from './components/AppointmentsHistory';
import { InsuredPersonProfileForm } from './components/InsuredPersonProfileForm';
import { PatientSummary } from './components/PatientSummary';
import { RecordsHistory } from './components/RecordsHistory';
import { ScheduleAppointmentButton } from './components/ScheduleAppointmentButton';

export const PatientProfile = (): React.ReactElement => {
  const params = useParams();
  const patientId = params?.id;
  const { state } = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);

  const handleOnBack = (): void => {
    if (state?.from) {
      navigate(state.from, { state: state.fromState });
    } else {
      navigate(ROUTES.PATIENTS);
    }
  };

  if (!patientId) {
    return <Navigate to={ROUTES.PATIENTS} />;
  }

  return (
    <div className="flex flex-col gap-10">
      <div className="flex items-center gap-2 justify-between">
        <Button variant="link" icon="leading" className="w-fit -ml-1 -mt-8" onClick={handleOnBack}>
          <ChevronLeft className="size-5" />
          <Text variant="text-sm-medium" className="text-teal-600 hover:text-teal-500">
            {t('AppointmentDetail.back')}
          </Text>
        </Button>
        <ScheduleAppointmentButton />
      </div>
      <PageHeader
        title={t('InsuredPersonsProfile.heading')}
        description={t('InsuredPersonsProfile.description')}
        className="-mt-6"
      />
      <div className="flex flex-col gap-12">
        <PatientSummary />
        <InsuredPersonProfileForm />
        <ActivePatientRecord />
        <RecordsHistory />
        <AppointmentsHistory />
      </div>
    </div>
  );
};
